// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FLimN{display:flex;align-items:center;gap:8px;flex-wrap:wrap}.hUYpP{padding-bottom:16px}.r1j5z{margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badges": `FLimN`,
	"modalContent": `hUYpP`,
	"root": `r1j5z`
};
export default ___CSS_LOADER_EXPORT___;
